import googleTagManager from './google-tag-manager';

export default googleTagManager;
